import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=9608ca54&scoped=true&"
import script from "./Separator.vue?vue&type=script&lang=ts&"
export * from "./Separator.vue?vue&type=script&lang=ts&"
import style0 from "./Separator.vue?vue&type=style&index=0&id=9608ca54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9608ca54",
  null
  
)

export default component.exports